import styled from 'styled-components';

export const StyledMachineCategoryIndicatorTooltip = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  .machine-category-indicator-tooltip__icon {
    color: ${(props): string => props.theme.colors.white};
    margin: 0 8px 0 0;
    width: 32px;
    height: 32px;
    text-align: center;

    svg {
      width: auto;
      height: auto;
    }
  }

  .machine-category-indicator-tooltip__info {
    flex: 1;
  }

  .machine-category-indicator-tooltip__title {
    ${(props): string => props.theme.fontStyles.redesign.sm.strong};
    margin-bottom: 4px;
  }

  .machine-category-indicator-tooltip__description {
    ${(props): string => props.theme.fontStyles.redesign.sm.normal};
    margin-bottom: 0;
  }
`;
